import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalFooter,
  Stack,
} from "@chakra-ui/react";
import { toast } from "react-toastify";
import { fetchController } from "../../../utils/FetchController/fetchController";
import { getHostDomain } from "../../../utils/utils";

export default function CallToolModal({ onClose, toolUserForm }) {
  const baseUrl = getHostDomain();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = toolUserForm;

  const onSubmit = async (data) => {
    if (Object.keys(errors)?.length) return;
    try {
      await fetchController(
        baseUrl + `/api/v1/tool/${data.tool_user_id}/LinkToolUser`,
        "PUT",
        {
          credentials: data.credentials,
        }
      );
      onClose();
      toast.success("Tool setup done");
    } catch (error) {
      toast.error("Some error occurred");
    }
  };

  return (
    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(onSubmit)(e); }}>
      <ModalBody>
        <Stack spacing={2}>
          <FormControl>
            <FormLabel>Call Forwarding Number</FormLabel>
            <Input
              {...register("credentials.configuration.call_forward_number")}
            />
          </FormControl>
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Button colorScheme="blue" type="button" onClick={handleSubmit(onSubmit)}>
          Finish
        </Button>
      </ModalFooter>
    </form>
  );
}
